export function getItemRequestData(apiOptions) {
    var requestData = {
        wset_id: apiOptions.workingSetId,
        app: apiOptions.app,
        url: apiOptions.url,
        type: apiOptions.mruType,
        mru_id: apiOptions.mruId,
        resource_id: apiOptions.resourceId,
        last_shared_datetime: apiOptions.lastSharedDateTime,
    };
    if (apiOptions.spoId) {
        requestData.spo_id = apiOptions.spoId;
    }
    return requestData;
}
//# sourceMappingURL=getItemRequestData.js.map